/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:05 PM
 */

'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Party = require('bunsen/models/Party');
var Anchor = require('bunsen/models/Anchor');
var ShipmentQuote = require('bunsen/models/logistics/ShipmentQuote');
var Shipment = require('bunsen/models/ecomm/Shipment');
var TransactionShipmentQuotes = require('bunsen/collections/ecomm/TransactionShipmentQuotes');
var Address = require('bunsen/models/Address');

/**
 * @mixin transactionShippingMixin
 */
module.exports = {
    getNumberOfPieces: function () {
        var item = this.get('item');
        var offer = this.getMostRecentOffer();

        if (!item || !offer) {
            // things are bad
            return 1;
        }

        if (item.soldIndividually()) {
            return offer.get('quantity');
        } else {
            return item.getNumberOfPieces();
        }
    },
    isEligibleFor1stdibsShipping: function () {
        return true;
    },
    /**
     * Returns true if shipping was known at checkout
     * @returns {Boolean}
     */
    isShippingKnownAtCheckout: function () {
        var isBuyerArrangedShipping = this.isBuyerShipping();
        var hasPreQuote = this.get('shipmentQuotes').hasPreQuoteIncludingCanceled();
        return hasPreQuote || isBuyerArrangedShipping;
    },
    /**
     * Returns true if buyer arranged shipping
     * @returns {Boolean}
     */
    isBuyerShipping: function () {
        return this.get('shipment').isBuyerArrangedShipping();
    },
    /**
     * Returns true if buyer arranged shipping
     * @deprecated Use isBuyerShipping instead
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        return this.isBuyerShipping();
    },

    /**
     * Returns true if dealer is shipping
     * @returns {Boolean}
     */
    isDealerShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && (acceptedQuote.isDealerBilledQuote() || this.is1stdibsSubsidizedDealerShipping());
    },

    /**
     * Returns true if dealer authored
     * the accepted quote
     * @returns {Boolean}
     */
    isDealerAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerAuthoredQuote();
    },

    isDealerBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerBilledQuote();
    },

    is1stdibsBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote();
    },

    /**
     * Return true if 1stdibs authored the quote
     * @returns {boolean}
     */
    is1stdibsAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return !!acceptedQuote && acceptedQuote.is1stdibsAuthoredQuote();
    },

    getShippingCostForTypeIn: function (costType, currency) {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote ? acceptedQuote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getCurrentShippingCostForTypeIn: function (costType, currency) {
        var quote = this.getCurrentShippingQuote();
        return quote ? quote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getShippingRequestReviewNoteContent: function () {
        var shipment = this.get('shipment');
        if (shipment) {
            return shipment.getShippingRequestReviewNoteContent();
        }
    },

    /**
     * Return true if the dealer needs to provide a shipment quote
     * @returns {boolean}
     */
    dealerQuoteNeeded: function () {
        var quotes = this.get('shipmentQuotes');
        return this.isShippingKnownAtCheckout() && !!quotes && !!quotes.noLocalPickupQuotes().length;
    },

    /**
     * Returns true if the item is shipped under the 1stdibs parcel
     * program (parcel shipping with a 1stdibs authored quote)
     * @returns {Boolean}
     */
    is1stdibsParcelShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsParcelQuote();
    },

    /**
     * Returns true if the item's shipping quote is authored by 1stdibs
     * and has white glove service method type
     * @returns {Boolean}
     */
    is1stdibsWhiteGloveShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsWhiteGloveQuote();
    },

    /**
     * Returns true if 1stdibs subsidizes the shipment
     * quote for the dealer. Right now this is true
     * only for 1sdibs parcel quotes and not for anything
     * else.
     * @returns {Boolean}
     */
    is1stdibsSubsidizedDealerShipping: function () {
        var accepted = this.getAcceptedQuote();
        return !!this.getAcceptedQuote() && accepted.is1stdibsSubsidizedDealerQuote();
    },

    /**
     * @returns {boolean}
     */
    isReadyToShip: function () {
        var shipment = this.get('shipment');
        return !!this.getAcceptedQuote() && this.isPending() && !shipment.hasBeenShipped();
    },

    /**
     * Returns true of an admin user has entered shipping info
     * for a transaction that has failed easy post address
     * registration. Currenlty, we know this is true when we
     * have a 1stdibs subsidized dealer shipping transaction
     * with an accepted, 1stdibs billed quote but no easypost-
     * supplied shipping label
     * @returns {boolean}
     */
    hasEnteredShippingInfo: function () {
        var activeQuote = this.getActiveAccountingShipmentQuote();
        return activeQuote &&
            this.is1stdibsSubsidizedDealerShipping() &&
            activeQuote.is1stdibsBilledQuote() &&
            activeQuote.wasAcceptedForAccounting() &&
            !this.getShipmentLabelURL();
    },

    /**
     * Returns true if 1stdibs (INTERNAL) is shipping
     * @returns {Boolean}
     */
    is1stdibsShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote() && !acceptedQuote.is1stdibsSubsidizedDealerQuote();
    },

    isPreQuote: function () {
        return this.get('shipmentQuotes').hasPreQuote();
    },
    isDealerPreQuote: function () {
        return this.isPreQuote() && this.isDealerBilledShipping();
    },
    is1stdibsPreQuote: function () {
        return this.isPreQuote() && this.is1stdibsShipping();
    },
    isLocalPickup: function () {
        return this.get('shipment').isLocalPickup();
    },
    isExternallyArranged: function () {
        return this.get('shipment').isExternallyArranged();
    },
    hasDealerRejectedQuote: function () {
        return !!this.getRejectedAccountingShipmentQuote();
    },
    /**
     * Get seller display val from the accepted shipment quote service method
     * @param [quote] Use this shipment quote instead of the accepted quote
     * @returns {*|string}
     */
    getSellerMethodDisplayVal: function (quote) {
        var serviceMethod;
        if (!quote) {
            quote = this.getAcceptedQuote();
        }
        serviceMethod = quote && quote.get('serviceMethod');
        if (serviceMethod) {
            return serviceMethod.getSellerMethodDisplayVal(this.getVertical());
        }
        return null;
    },
    /**
     * @deprecated Use isBuyerArrangedShipping, isDealerAuthoredShipping, and is1stdibsShipping instead;
     * @returns {String}
     */
    getShipper: function () {
        if (this.isBuyerShipping()) {
            return Party.ROLE_BUYER;
        } else if (this.isDealerShipping()) {
            return Party.ROLE_SELLER;
        } else if (this.is1stdibsShipping()) {
            return Party.ROLE_INTERNAL;
        }
        return null;
    },
    getBuyerShipmentMethodName: function () {
        var quote = this.getBuyerShipmentQuote();
        var method;

        if (quote.isLocalPickup()) {
            method = "Customer will pick up from dealer";
        } else if (quote) {
            method = quote.getBuyerServiceMethodDisplayValue();
        } else if (this.isBuyerShipping()) {
            method = "Customer Will Handle Shipping";
        } else {
            method = "TBD";
        }
        return method;
    },
    getShipmentAddresseeDisplayName: function () {
        return this.get('shipment').getAddresseeDisplayName();
    },
    getShipmentCountry: function () {
        return this.get('shipment.shippingAddress.country');
    },
    getShipmentType : function () {
        return this.get('shipment.shipmentType') || null;
    },
    getShipmentTypeDisplayVal: function () {
        if (this.isLocalPickup()) {
            return 'Customer Pickup';
        } else if (this.isBuyerShipping()) {
            return 'Customer Will Handle Shipping';
        } else if (this.isDealerPreQuote()) {
            return 'Dealer Flat Rate';
        } else if (this.is1stdibsSubsidizedDealerShipping() && this.is1stdibsParcelShipping()) {
            return '1stdibs Parcel Shipping';
        } else if (this.is1stdibsShipping()) {
            return '1stdibs Shipping';
        } else if (this.isDealerShipping()) {
            return 'Dealer Shipping';
        } else {
            return 'Customer Needs Item Shipped';
        }
    },

    /**
     * Get the shipment label
     * @returns {string}
     */
    getShipmentLabelURL: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingLabelURL() : null;
    },

    /**
     * @returns {string}
     */
    getShipmentTrackingNumber: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingNumber() : null;
    },

    /**
     * Get a new Note anchored to the shipment (and
     * other standard transactions)
     * @param {object} noteOptions
     * @returns {Note}
     */
    newNoteForShipment: function (noteOptions) {
        return this.newNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * Get a new note of type BUYER_SELLER anchored
     * to the shipment;
     * @param noteOptions
     * @returns {Note}
     */
    newBuyerSellerNoteForShipment: function (noteOptions) {
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newBuyerSellerNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    _getShipmentQuoteAnchorAttrs: function (shipmentQuote) {
        return {
            sourceId: shipmentQuote.id,
            sourceType: Anchor.TYPE_SHIPMENT_QUOTE
        };
    },
    _getShipmentAnchorAttrs: function () {
        return {
            sourceType: Anchor.TYPE_SHIPMENT,
            sourceId: this.get('shipment').id
        };
    },
    /**
     * sets the shipping address with a unified event
     * @param address
     */
    setShippingAddress: function (address) {
        this.get('shipment').set('shippingAddress', address);
        this.trigger('shippingAddressChanged');
    },
    /**
     * Used before checkout to make a transaction use a shipment quote
     */
    setShipmentQuote: function (shipmentQuote) {
        if (shipmentQuote.isLocalPickup()) {
            this.get('shipment').set('shipmentType', Shipment.TYPE_LOCAL_PICKUP);
        } else {
            this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        }
        this.get('shipmentQuotes').reset([shipmentQuote]);
        this.get('shipment').set('acceptedQuote', shipmentQuote);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction externally arranged
     */
    setExternallyArranged: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_EXTERNALLY_ARRANGED);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction "quote needed"
     */
    setQuoteNeeded: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        this.trigger('shippingChanged');
    },
    fetchAvailableOptions: function (address) {
        var availableOptions = new TransactionShipmentQuotes();
        var currencyConversionRateEventId = this.get('currencyConversionRateEvent.id');
        var item = this.get('item');

        address = address || this.get('shipment.shippingAddress');

        if (!(address && address.get('country'))) {
            address = new Address({country: 'US'});
        }

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(item, address, currencyConversionRateEventId).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },
    selectFirstAvailableOption: function () {
        var quote = this.availableOptions.getNonLocalShipmentQuotes()[0];
        if (quote) {
            this.setShipmentQuote(quote);
        } else {
            this.setQuoteNeeded();
        }
    },
    showOverrideUpsLabel: function () {
        var shipment = this.get('shipment');
        var hasBeenShipped = shipment.hasBeenShipped();
        var hasFailedAddressRegistration = shipment.hasFailedAddressRegistration();
        return !!(this.isConfirmed() && this.is1stdibsParcelShipping() && hasBeenShipped === false && hasFailedAddressRegistration === false);
    },
    /**
     * Returns true or false depending on whether UPS label override was successful.
     * Checks that there are two accounting quotes: one canceled and one accepted.
     */
    wasOverrideUpsLabelSuccessful: function () {
        var shipmentQuotes = this.get('shipmentQuotes');
        var canceledQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "CANCELED";
        });
        var acceptedQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "ACCEPTED";
        });
        return !!(canceledQuote && acceptedQuote);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/ecomm/Transaction/transactionShippingMixin.js
// module id = 197
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56